<template>
  <div>
    <apexchart ref="chart" width="500" type="bar" :options="options" :series="series"></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
export default {
  name: "Chart",
  components: {
    apexchart: VueApexCharts
  },
  props: ["series", "options"],
  data() {
    return {};
  },
  methods: {
 
  }
};
</script>

<style>
</style>
